/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し）
 * @export
 * @enum {number}
 */
export enum MeterModeEnum {
    /** 迎車連携有り */
    WITH_PICKUP_COOPERATION = '0',
    /** 迎車連携無し */
    WITHOUT_PICKUP_COOPERATION = '1',
    /** メータ無し */
    NO_METER = '2'
}

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し） の Union 型
 * @export
 * @typedef MeterMode
 */
export type MeterMode =
  typeof MeterModeEnum[keyof typeof MeterModeEnum];

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し） のラベルマップ
 * @export
 */
export const MeterModeLabels = {
    /**
     * 数値キー: MeterModeEnum.WITH_PICKUP_COOPERATION
     * 名前キー:  WITH_PICKUP_COOPERATION
     */
    [MeterModeEnum.WITH_PICKUP_COOPERATION]: '迎車連携有り',
    WITH_PICKUP_COOPERATION:                             '迎車連携有り',
    /**
     * 数値キー: MeterModeEnum.WITHOUT_PICKUP_COOPERATION
     * 名前キー:  WITHOUT_PICKUP_COOPERATION
     */
    [MeterModeEnum.WITHOUT_PICKUP_COOPERATION]: '迎車連携無し',
    WITHOUT_PICKUP_COOPERATION:                             '迎車連携無し',
    /**
     * 数値キー: MeterModeEnum.NO_METER
     * 名前キー:  NO_METER
     */
    [MeterModeEnum.NO_METER]: 'メータ無し',
    NO_METER:                             'メータ無し',
} as const;

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し） のラベル Union 型
 * @export
 * @typedef MeterModeLabel
 */
export type MeterModeLabel =
  typeof MeterModeLabels[keyof typeof MeterModeLabels];

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し） のラベル取得関数
 * @export
 * @param { MeterMode } value - 列挙体の値
 * @returns { MeterModeLabel } ラベル文字列
 */
export function getMeterModeLabel(
  value: MeterMode
): MeterModeLabel {
  return MeterModeLabels[value];
}

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し） のラベル配列を取得する関数
 * @export
 * @param { MeterMode[] } values - 列挙体の値配列
 * @returns { MeterModeLabel[] } ラベル文字列配列
 */
export function getMeterModeLabels(values: MeterMode[]): MeterModeLabel[] {
  return values.map((value) => getMeterModeLabel(value));
}

/**
 * メーターモード (0:迎車連携有り 1:迎車連携無し 2:メータ無し） のラベル配列
 * @export
 */
export const MeterModeLabelList = [
  '迎車連携有り','迎車連携無し','メータ無し',
] as const;

